module.exports = __webpack_public_path__ + "img/sales-manager-color.06d8c24c.png";